<!-- @veltra/icons generated sha256:66526f3a716c34ab gen:8 source:src/svg/normal/books.svg -->
<script setup lang="ts">
defineOptions({ name: 'Books' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M7.418 9.685 4 12.078v-9.08h8v9.08L8.58 9.685a1.02 1.02 0 0 0-1.16 0m1.157 1.218 3.636 2.545a.5.5 0 0 0 .787-.41V2.999a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10.04a.5.5 0 0 0 .787.41l3.636-2.545c.344-.241.81-.241 1.154 0"
    />
  </svg>
</template>
